import './DetailEmailTicket.css';
import Storage from '@/amplify/storage';
import Utils from '@/common/utils/utils';
import { formatUserDateTime } from '@/common/utils/timezoneUtils';
import Constant from '@/common/constant/Constant';
import moment from 'moment';
import { cloneDeep, isEqual } from 'lodash';
import { useState, useEffect, useMemo } from 'react';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import useRevalidateOnTranslation from '@/hooks/useRevalidateOnTranslation';
import DetailContentOnDemandControl from '../../multiLanguage/elements/DetailContentOnDemandControl';
import LoadingPanel from '../../common/LoadingPanel';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import {
    checkDetailTicket,
    deleteAllTicketData,
    getTicketDetailAPI
} from '@/service/ticketService';
import { FormProvider, useForm } from 'react-hook-form';

// import Atom
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { contentDetailOnDemandAtom } from '@/state/atom/translationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { initContentDetailOnDemand } from '@/component/multiLanguage/handlers/DetailContentOnDemandHandler';
import { userAtom } from '@/state/atom/userAtom';
import { detailEmailTicketAtom, openReplyDetailEmailAtom } from '@/state/atom/emailTicketAtom';

import { panelInitDataAtom, closeTabId, multiPanelAtom, reloadChatThreadPanelAtom, triggerReloadMenuAtom, reloadTicketDetailIdAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector, setPanelSelector, triggerReloadTab, triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';

import { yupResolver } from '@hookform/resolvers';
import CustomSchema from '@/schema/CustomSchema';
import {showLoadingMouse, hideLoadingMouse} from '../../../common/utils/CustomCursor';

import { getPublicAPI } from '@/service/publicService';
import { signOut } from '@/service/authenService';

import {
    removePanelInitData,
    updatePanelInitData,
    getPanelInitData,
} from '../../multiPanel/panel/handler/PanelHandler';
import { useSnackbar } from 'notistack';


import { handleCreateReplyEmailTicket, processEmailAddressList, getOriginEmailSubjectValue, handleGetUploadFileList } from './DetailEmailTicketHandler';

// import elements
import HeaderButton from './elements/HeaderButton';
import FooterEmailTicket from './elements/FooterEmailTicket';
import EscalationEmailTicket from './elements/EscalationEmailTicket';
import PaginationButton from './elements/PaginationButton';
import OriginEmailAssignField from './elements/OriginEmailAssignField';
import OriginStatusField from './elements/OriginStatusField';

import ReplyEmailTicketForm from './replyEmailTicket/ReplyEmailTicketForm';
import ContentCurrentEmailTicket from './currentEmailTicket/ContentCurrentEmailTicket';

import { DialogConfirmSoftDeleteTicket } from '../listTicketDialog/DialogConfirmSoftDeleteTicket';
import { handleArchiveTicket, handleBackToArrivalTicket, submitSoftDeleteTicket } from '@/component/chatThread/handler/DetailTicketHandler';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import { isTicketCountNumber } from '../handler/TicketHandler';
import { getCorporationDetailByCorporationDomain } from '@/service/organizationService';
import { DialogConfirmChangeTicketError } from '../addTicketDialog/DialogConfirmChangeTicketError';
import { DialogConfirmForceEditTicket } from '../listTicketDialog/DialogConfirmForceEditTicket';
import { DialogConfirmCancelEditTicket } from '../../chatThread/editTicketDialog/DialogConfirmCancelEditTicket';
import ErrorMessageHeader from '@/component/common/ErrorMessageHeader';
import '@/component/common/ErrorMessageHeader.css';
// behaviors
import { submitUpdateTicket, isInputAllFieldRequiredWhenEditTicket } from '../../chatThread/handler/DetailTicketHandler';
import { getRichTextFieldContent, closePanelTabDetailTicket } from '@/component/ticketList/handler/TicketHandler';
import { createEmailTicketHandler } from '../handler/HelpdeskCreateTicketHandler';
import CopyIdElement from '@/component/common/CopyIdElement';
import { PropTypes } from 'prop-types';
import { triggerReLoadHelpdeskTicketDetailAtom } from '@/state/atom/ticketAtom';
import { Popover, Button } from '@material-ui/core';
import AttachFileChatPost from '@/component/attachFile/AttachFileChatPost';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

// define props using in this component. targetTicketIdOfChatPost is new field. others fields still working
DetailEmailTicket.propTypes = {
    targetTicketIdOfChatPost: PropTypes.string,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any,
    componentName: PropTypes.any,
};

function DetailEmailTicket(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    // global state
    const selectedProject = useRecoilValue(projectInuseDetailAtom);
    const currentUserDetail = useRecoilValue(userAtom);

    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    const [contentDetailOnDemand, setContentDetailOnDemand] = useRecoilState(contentDetailOnDemandAtom);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const setTriggerReloadMenu = useSetRecoilState(triggerReloadMenuAtom);
    const [reloadChatThread ,setReloadChatThread] = useRecoilState(reloadChatThreadPanelAtom);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const reloadTicketDetailId = useRecoilValue(reloadTicketDetailIdAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [statusOfTicket, setStatusOfTicket] = useState({})
    const [newStatusData,setNewStatusData] = useState({})
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const { enqueueSnackbar } = useSnackbar();
    const [triggerEmailTicket, setTriggerEmailTicket] = useRecoilState(detailEmailTicketAtom);
    const [triggerOpenReplyEmail, setTriggerOpenReplyEmail] = useRecoilState(openReplyDetailEmailAtom);
    const isGeneralUser = Utils.isGeneralUser(currentUserDetail);

    // component state
    const [fieldListDefaultData, setFieldListDefaultData] = useState([]);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [detailTicket, setDetailTicket] = useState({});
    const [formDetail, setFormDetail] = useState({});
    const [emailTicketList, setEmailTicketList] = useState([]);
    const [currentPage, setCurrentPage] = useState(null);
    const [triggerReloadTicket, setTriggerReloadTicket] = useState(0);

    const [isOpenPopupSoftDelete, setIsOpenPopupSoftDelete] = useState(false);
    const [isSoftDelete, setIsSoftDelete] = useState(false);
    const [isShowDialogRestoreTicket, setIsShowDialogRestoreTicket] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [contentModalReloadPage, setContentModalReloadPage] = useState('');
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    const [errorMessageHeader, setErrorMessageHeader] = useState('');

    const reloadPanelAfterSoftDeleteTicketByPanelType = useSetRecoilState(triggerReloadTab);
    const [isConfirmDialogObj, setIsConfirmDialogObj] = useState(false);
    const [isOpenPopupTicketError, setIsOpenPopupTicketError] = useState(false);
    const [isOpenPopupTicketMsg, setIsOpenPopupTicketMsg] = useState(false);
    const isGeneralUserWithGuest = Utils.isGeneralUser(currentUserDetail);
    const [isDisplayEditTicket, setIsDisplayEditTicket] = useState(false);
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const [fileDeletedList, setFileDeletedList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [mapDataIdToId, setMapDataIdToId] = useState({});
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [newAssignee, setNewAssignee] = useState('');
    const [statusNo, setStatusNo] = useState(0);
    const [newStatusOfTicket,setNewStatusOfTicket] = useState('')
    const [isHelpDesk, setIsHelpDesk] = useState(false)
    const [isMe, setIsMe] = useState(false);
    const [isEditTicket, setIsEditTicket ] = useState(false);
    const [isDisableEdit, setIsDisableEdit] = useState(false);
    const [newAssigneeData,setNewAssigneeData] = useState({})
    const [currentAssigneeUserData, setCurrentAssigneeUserData] = useState({});
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const [projectMailSetting, setProjectMailSetting] = useState(null);
    const [replyToEmailTicket, setReplyToEmailTicket] = useState(null);
    const [toEmailAddressList, setToEmailAddressList] = useState([]);
    const [ccEmailAddressList, setCcEmailAddressList] = useState([]);
    const [bccEmailAddressList, setBccEmailAddressList] = useState([]);
    const [listSuggestSearchEmail, setListSuggestSearchEmail] = useState([]);
    const [isEdited, setIsEdited] = useState(false);
    const [isShowDialogBackToArrivalTicket, setIsShowDialogBackToArrivalTicket] = useState(false);
    const [listTicketChild, setListTicketChild] = useState([])
    const [viewFromProjectOfEscalateTicket, setViewFromProjectOfEscalateTicket] = useState(false);
    const [flagReset, setFlagReset] = useState(false);
    const [mailDefaultData, setMailDefaultData] = useState({
        toEmailAddressList: [],
        ccEmailAddressList: [],
        bccEmailAddressList: [],
        currentMailSubject: '',
        currentMailBody: { value: '', error: '' },
        currentTicketDeliverStatus: false,
        fileUpdatedList: [],
        status: {},
        assignee: {}
    });

    // for edit current ticket
    const [isEditedCurrentTicket, setIsEditedCurrentTicket] = useState(false);
    const [isSelectDeliver, setIsSelectDeliver] = useState(false);
    const [currentTicketDeliverStatus, setCurrentTicketDeliverStatus] = useState(false);
    const [currentTicketFields, setCurrentTicketFields] = useState([])
    const [currentMailSubject, setCurrentMailSubject] = useState('')
    const [currentMailBody, setCurrentMailBody] = useState({value: '', error: ''})
    const [currentAttachmentError, setCurrentAttachmentError] = useState('');
    const [isTriggerReloadCurrentTicket, setIsTriggerReloadCurrentTicket] = useState(false)
    const [anchorShowMoreActionsPopover, setAnchorShowMoreActionsPopover] = useState(null);
    const [displayPopupConfirmCancel, setDisplayPopupConfirmCancel] = useState(false);
    const [displayMode, setDisplayMode] = useState(Constant.DISPLAY_MODE.VIEW);
    const isOpenShowMoreOptionsPopover = useMemo(() => {
        return Boolean(anchorShowMoreActionsPopover) || false;
    }, [anchorShowMoreActionsPopover]);

    // for reply to email ticket
    const [replyDefaultData, setReplyDefaultData] = useState([]);
    const [isReplyEditData, setIsReplyEditData] = useState(false);
    const [fileReplyUploadList, setFileReplyUploadList] = useState([]);
    const [replyDeliverStatus, setReplyDeliverStatus] = useState(false);
    const [isDisableBtnSave, setIsDisableBtnSave] = useState(true);
    const [replyConfirm, setReplyConfirm] = useState({
        isOpen: false,
        msg: trI18n('MSG-CM-CANCEL_REPLY'),
        isAction: ''
    });
    const [
        triggerReLoadHelpdeskTicketDetail,
        setTriggerReLoadHelpdeskTicketDetail
    ] = useRecoilState(triggerReLoadHelpdeskTicketDetailAtom);

    const validateReplyTicket = useForm({
        mode: 'all',
        shouldUnregister: true,
        defaultValues: {
            outline: '',
            category: '',
            description: '',
            field_qa_category: []
        },
        resolver: yupResolver(CustomSchema(replyDefaultData))
    });
    const handleReplyTicket = validateReplyTicket.handleSubmit;
    const errorReplyTicket = validateReplyTicket.errors;
    const clearErrorReplyTicket = validateReplyTicket.clearErrors;
    const setValueReplyTicket = validateReplyTicket.setValue;
    const registerReplyTicket = validateReplyTicket.register;
    const unregisterReplyTicket = validateReplyTicket.unregister;
    const getValuesReplyTicket = validateReplyTicket.getValues;
    const resetValuesReplyTicket = validateReplyTicket.reset;
    const setErrorReplyTicket = validateReplyTicket.setError;
    // Rebuild error messages that are already shown once the translation dictionary loads.
    useRevalidateOnTranslation(errorReplyTicket, validateReplyTicket.trigger);
    // for reply to email ticket

    const validateEditTicket = useForm({
        mode: 'all',
        resolver: yupResolver(CustomSchema(fieldListDefaultData))
    });
    const errorEditTicket = validateEditTicket.errors;
    const clearErrors = validateEditTicket.clearErrors;
    const setValueEditTicket = validateEditTicket.setValue;
    const registerEditTicket = validateEditTicket.register;
    const getValuesEditTicket = validateEditTicket.getValues;
    const setErorsEditTicket = validateEditTicket.setError;
    const warpSubmitEditTicket = validateEditTicket.handleSubmit;    
    // Rebuild error messages that are already shown once the translation dictionary loads.
    useRevalidateOnTranslation(errorEditTicket, validateEditTicket.trigger);
    const [forceEditTicketObject, setForceEditTicketObject] = useState({
        method: 0,
        requestDto: {}
    });
    const [isConfirmCancelEditTicket, setIsConfirmCancelEditTicket] = useState(false);


    const currentTabData = useMemo(() => {
        const panel = panelInitData.find(p => p?.id === props?.panelId);
        if (!panel) return;
        const tab = (panel?.tabList || []).find(t => t?.id === props?.tabId)?.data;
        return tab
    }, [panelInitData, props?.tabId, props?.panelId]);

    useEffect(() => {
        const fetchInitData = async () => {
            setIsLoading(true);
            showLoadingMouse();
            
            try {
                const [{ticketDetail, totalPages, emailTickets}, ...res] = await Promise.all([
                    getTicketDetail(props.ticketId, false),
                    initProjectEmailSettingData()
                ]);
                if (!Utils.isEmptyString(props?.targetTicketIdOfChatPost)) {
                    let targetTicketIdx = emailTickets?.findIndex(
                        emailTicket => emailTicket?.id === props?.targetTicketIdOfChatPost
                    );
                    if(targetTicketIdx == -1) targetTicketIdx = totalPages
                    setCurrentPage(targetTicketIdx + 1);
                    if (props.hasOwnProperty('targetTicketIdOfChatPost')) {
                        delete props.targetTicketIdOfChatPost;
                    }
                } else {
                    setCurrentPage(
                        isEditedCurrentTicket
                            ? currentPage > 1 && currentPage < totalPages
                                ? currentPage
                                : totalPages
                            : totalPages
                    );
                }
                
                // reset form
                validateEditTicket?.reset();
                // reset reply ticket
                resetValuesReplyTicket();
                setNewAssignee('')
                setIsHelpDesk(true);
            } catch (error) {
                console.error("fetchInitData error:", error);
            } finally {
                setIsLoading(false);
                hideLoadingMouse();
            }
        };
        
        fetchInitData();
    }, [
        props.ticketId,
        selectedProject?.id, 
        props.triggerReload,
        triggerReloadTicket
    ]);

    const handleCloseTab = (isEditedTabTicket, isEditedChildTicket) => {
        const panelType = getPanelType();

        let closePanelParams = {
            isEdited: false, 
            setIsOpenPopupConfirm: setIsConfirmCancelEditTicket, 
            panelType: panelType, 
            panelId: props.panelId, 
            detailTicket: detailTicket, 
            panelList: panelList,   
            closePanelTab: closePanelTab, 
            setCloseTabIdState: setCloseTabIdState,
            removePanelInitData: removePanelInitData,
            panelInitData: panelInitData,
            setPanelInitData: setPanelInitData
        }

        let edited = false
        if (isEditedChildTicket === true) {
            const validateFields = currentTicketIsEdited();
            if (!validateFields) {
                closePanelTabDetailTicket(closePanelParams);
                return;
            }
        }

        if (isEditedTabTicket === true || isEditedChildTicket === true) {
            edited = true
        }

        closePanelParams.isEdited = edited;
        closePanelTabDetailTicket(closePanelParams);
    }

    // handle close tab
    useEffect(() => {
        if (
            props.tabId === closeTabIdState ||
            (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_EMAIL && closeTabIdState === detailTicket.id)
        ) {
            handleCloseTab(isEdited, isEditedCurrentTicket)
        }
    }, [closeTabIdState]);

    useEffect(() => {
        if (reloadTicketDetailId.includes(props.ticketId)) {
            setTriggerReloadTicket(Date.now().toString());
        }
    }, [reloadTicketDetailId]);

    // in customer chatthread, user click メール詳細, so open detail ticket
    useEffect(() => {
        if (triggerEmailTicket?.open && !Utils.isEmptyString(triggerEmailTicket?.ticketId)) {
            if (!Utils.isEmptyArray(emailTicketList)) {
                for(let index = 0; index < emailTicketList.length; index++) {
                    if (triggerEmailTicket?.ticketId === emailTicketList[index]?.id && index !== currentPage - 1) {
                        setCurrentPage(index + 1);
                        break;
                    }
                }
            }
            setTriggerEmailTicket({open: false, ticketId: null});
            let isReplyTicket = !!replyToEmailTicket;
            if (isReplyTicket) {
                onClickCancelReplyTicket();
            }
        }
    }, [triggerEmailTicket]);

    // in customer chatthread, user click メール詳細 in footer, so open reply email
    useEffect(() => {
        if (triggerOpenReplyEmail?.open && !Utils.isEmptyString(triggerOpenReplyEmail?.ticketId)) {
            if(!Utils.isEmptyArray(emailTicketList)) {
                if(!triggerOpenReplyEmail?.triggerData?.isOriginTicket) {
                    for(let index = 0; index < emailTicketList.length; index++) {
                        if(triggerOpenReplyEmail?.ticketId === emailTicketList[index]?.id) {
                            openReplyEmail({...emailTicketList[index]}, triggerOpenReplyEmail.triggerData);
                        }
                    }
                }else {
                    openReplyEmail({...emailTicketList[0]}, triggerOpenReplyEmail.triggerData);
                }
            }
            setTriggerOpenReplyEmail({open: false, ticketId: null, triggerData: {}});
        }
    }, [triggerOpenReplyEmail]);

    useEffect(() => {
        triggerEnableBtnSaveTicket();
    }, [currentTicketDeliverStatus, isEdited, fileReplyUploadList, isEditedCurrentTicket]);

    useEffect(() => {
        const panelHelpdeskTicketList = panelList.filter(panel =>
            [
                Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
            ].includes(panel.type)
        );
        let newPanelList = cloneDeep(panelList);
        panelHelpdeskTicketList?.forEach(panelHelpdeskTicket => {
            let tabDeletedHelpdeskTicket = panelHelpdeskTicket.tabList?.map(tab =>
                tab.id === detailTicket?.id
                    ? {
                          ...tab,
                          isTicketDeleted: !Utils.isEmptyString(detailTicket.deletedAt)
                              ? true
                              : false
                      }
                    : tab
            );
            const newPanelHelpdeskTicket = {
                ...panelHelpdeskTicket,
                tabList: tabDeletedHelpdeskTicket
            };
            newPanelList = newPanelList.map(panel =>
                panel.type === panelHelpdeskTicket.type ? (panel = newPanelHelpdeskTicket) : panel
            );
        });

        setPanelList(newPanelList);
    }, [isSoftDelete])

    useEffect(() => {
        const currentPanelInitDataRes = getPanelInitData(props.panelId, props.tabId, panelInitData);
        if (!currentPage) {
            return;
        }
        setIsTriggerReloadCurrentTicket(false);
        if (
            !Utils.isEmptyObject(currentPanelInitDataRes) &&
            !Utils.isEmptyArray(currentPanelInitDataRes['emailTicketList'])
        ) {
            setCurrentPanelInitData(currentPanelInitDataRes);
            setEmailTicketList(currentPanelInitDataRes['emailTicketList']);
        }

        const emailTicketListValue = currentPanelInitDataRes['emailTicketList'] ?? emailTicketList;

        const page =
            currentPage > emailTicketListValue.length ? emailTicketListValue.length : currentPage;
        const currentEmailTicket = emailTicketListValue[page - 1];
        const formData = currentEmailTicket?.mailFormData || {};

        setIsSelectDeliver(formData['isSelectDeliver'] ?? false);
        setDisplayMode(formData['displayMode'] ?? Constant.DISPLAY_MODE.VIEW);
        setIsEdited(formData['isEdited'] ?? false);
        setIsEditedCurrentTicket(formData['isEditedCurrentTicket'] ?? false);
        setFileUploadList(formData['fileUploadList'] ?? []);
        setFileDeletedList(formData['fileDeletedList'] ?? []);
        setNewStatusData(formData['newStatusData'] ?? mailDefaultData?.status?.currentItemData);
        setStatusOfTicket(prev => {
            return {
                ...prev,
                currentItemData:
                    formData['newStatusData'] ?? mailDefaultData?.status?.currentItemData
            };
        });
        setNewAssigneeData(formData['newAssigneeData'] ?? mailDefaultData?.assignee);
        setCurrentAssigneeUserData(formData['newAssigneeData'] ?? mailDefaultData?.assignee);

        let isProjectEmail =
            currentEmailTicket?.projectOrigin === currentEmailTicket?.affiliationProject;
        let isDeliverStatus = true;
        if (
            currentEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY &&
            isProjectEmail &&
            currentEmailTicket.deliverInfo &&
            !currentEmailTicket.deliverInfo.status
        ) {
            isDeliverStatus = false;
        }

        setCurrentTicketDeliverStatus(formData['currentTicketDeliverStatus'] ?? isDeliverStatus);

        // when next/back ticket child, get init list field
        setCurrentTicketFields(currentEmailTicket.listField || []);

        // Init/refresh on-demand state for the current child email, keyed by its id
        // (rebuilt with fresh field values until translated, then left untouched).
        // Pass the root ticket id (the tab id) so this child is the tab's active record
        // and the tab title follows the page being viewed.
        if (currentEmailTicket?.id) {
            initContentDetailOnDemand(
                setContentDetailOnDemand,
                currentEmailTicket,
                currentEmailTicket?.listField || [],
                detailTicket?.ticketOutline,
                detailTicket?.id
            );
        }

        const listField = currentEmailTicket.listField;

        let toEmailAddressListDefault;
        let ccEmailAddressListDefault;
        let bccEmailAddressListDefault;
        let currentMailSubjectDefault;
        let currentMailBodyDefault;
        let fileUpdatedListDefault;

        for (let field of listField) {
            switch (field.sysField) {
                case Constant.SYS_FIELD.TO:
                    setToEmailAddressList(formData['toEmailAddressList'] || field.value || []);
                    toEmailAddressListDefault = field.value || [];
                    break;
                case Constant.SYS_FIELD.CC:
                    setCcEmailAddressList(formData['ccEmailAddressList'] || field.value || []);
                    ccEmailAddressListDefault = field.value || [];
                    break;
                case Constant.SYS_FIELD.BCC:
                    setBccEmailAddressList(formData['bccEmailAddressList'] || field.value || []);
                    bccEmailAddressListDefault = field.value || [];
                    break;
                case Constant.SYS_FIELD.MAIL_SUBJECT:
                    setCurrentMailSubject(formData['currentMailSubject'] || field.value || '');
                    currentMailSubjectDefault = field.value || '';
                    break;
                case Constant.SYS_FIELD.MAIL_BODY:
                    setCurrentMailBody(
                        formData['currentMailBody'] || {
                            value: field.value ? field.value : '',
                            error: ''
                        }
                    );
                    currentMailBodyDefault = { value: field.value ? field.value : '', error: '' };
                    break;
                case Constant.SYS_FIELD.ATTACHMENTS:
                    setFileUpdatedList(formData['fileUpdatedList'] || [...field.value]);
                    fileUpdatedListDefault = [...field.value];
                    break;
                default:
                    break;
            }
        }

        setMailDefaultData(prev => {
            return {
                ...prev,
                toEmailAddressList: toEmailAddressListDefault,
                bccEmailAddressList: bccEmailAddressListDefault,
                ccEmailAddressList: ccEmailAddressListDefault,
                currentMailBody: currentMailBodyDefault,
                currentMailSubject: currentMailSubjectDefault,
                currentTicketDeliverStatus: isDeliverStatus,
                fileUpdatedList: fileUpdatedListDefault
            };
        });

        // handle loading to load attachment when change ticket
        triggerEnableBtnSaveTicket();
        const timeoutId = setTimeout(() => {
            // do nothing
        }, 1000);

        // Cleanup function
        return () => clearTimeout(timeoutId);
    }, [currentPage, isTriggerReloadCurrentTicket]);

    let argsAll = {
        ...props,
        API: props?.API,
        panelId: props.panelId,
        corporationDetail,
        selectedProject,
        currentUserDetail,
        setCorporationDetail,
        detailTicket,
        setDetailTicket,
        isLoading,
        setIsLoading,
        fieldListDefaultData,
        setFieldListDefaultData,
        isEdited,
        setIsEdited,
        isDisplayEditTicket,
        setIsDisplayEditTicket,
        fileUploadList,
        setFileUploadList,
        fileUpdatedList,
        fileUploading,
        setFileUploading,
        mapDataIdToId,
        setMapDataIdToId,
        triggerReloadTicket,
        setTriggerReloadTicket,
        newStatusOfTicket,
        statusOfTicket,
        isMe, 
        setIsMe,
        setNewAssignee,
        newAssignee,
        listFieldEdited,
        setListFieldEdited,
        formDetail,
        isHelpDesk,
        panelInitData, 
        setPanelInitData,
        currentPanelInitData,
        setCurrentPanelInitData,
        setFileUpdatedList,
        setIsEditTicket,
        forceEditTicketObject,
        setForceEditTicketObject,
        setIsOpenModalReloadPage,
        setContentModalReloadPage
    };

    const getTicketDetail = async (ticketId, isFromEditTicket=false) => {
        setIsLoading(true);
        //get ticket detail
        let ticketDetailResult = await getTicketDetailAPI(props?.API, ticketId, selectedProject.id, currentUserDetail.id, false);
        // console.log('namnhdebug ticketDetailResult', ticketDetailResult);

        if (!ticketDetailResult || ticketDetailResult?.errors?.length > 0) return;

        let formDetailObject = Utils.convertJSONDataToObject(ticketDetailResult.formDetail);
        let formDetailId = Utils.convertJSONDataToObject(ticketDetailResult?.formDetail)?.id;

        let ticket = ticketDetailResult.detailTicket;
        ticket.dataShareLink = Utils.convertJSONDataToObject(ticketDetailResult?.dataShareLink);
        ticket.attachFiles = Utils.convertJSONDataToObject(ticketDetailResult?.attachFiles);
        const createAt = new Date(ticket.createdAt);

        ticket.usingFormName = ticketDetailResult.usingFormName;
        ticket.createTime = formatUserDateTime(ticket.createdAt, 'YYYY/MM/DD HH:mm', currentUserDetail?.userSetting);
        ticket.updatedTime = formatUserDateTime(ticket.updatedAt, 'YYYY/MM/DD HH:mm', currentUserDetail?.userSetting);

        if (
            selectedProject?.id !== ticket.projectOrigin &&
            selectedProject?.id !== ticket.affiliationProject &&
            !ticket.projectTarget.includes(selectedProject?.id) &&
            ![
                Constant.TICKET_TYPE.TASK,
                Constant.TICKET_TYPE.BROADCAST_PARENT,
                Constant.TICKET_TYPE.BROADCAST_CHILD,
            ].includes(ticket.ticketType)
        ) {
            setViewFromProjectOfEscalateTicket(true);
        }

        // set ticket projectOriginName
        if (ticketDetailResult?.selectedProjectIsProjectOrigin) {
            const projectOrigin = selectedProject;
            let projectOriginName = "";

            if (projectOrigin.type === Constant.PROJECT_TYPE.BASE) {
                projectOriginName = Constant.PROJECT_BASE_DISPLAY_NAME;
            } else {
                projectOriginName = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    projectOrigin.name
                );
            }

            ticket.projectOriginName = projectOriginName;
        }
        // set ticket createrUserName
        if (ticketDetailResult?.currentUserIsCreator) {
            let createrUserName = Utils.getFullNameOfUser(
                Constant.LANGUAGE_TYPE.JP,
                currentUserDetail
            );
            if (!Utils.isEmptyString(createrUserName)) {
                createrUserName = createrUserName.replace('\n', ' ');
            }
            ticket.createrUserName = createrUserName;
        }

        /**set status value for status field. */
        const status = Utils.convertJSONDataToObject(ticket.status);
        const statusDetail = Utils.convertJSONDataToObject(ticket.statusDetail);
        setStatusNo(statusDetail.no)
        if (!Utils.isEmptyString(status) && !Utils.isEmptyObject(statusDetail)) {
            /**
             * ticket status = done and project setting mail = off. don't allow edit assign and status.
             * status = done and project is not desk on public on. don't allow edit assign and status
             */
            if (
                (!Utils.isEnableCreateEmailTicketMode(corporationDetail, selectedProject) &&
                    statusDetail?.no === Constant.STATUS_NO.DONE) ||
                (statusDetail?.no === Constant.STATUS_NO.DONE &&
                    !Utils.isPublicDesk(selectedProject))
            )
                setIsDisableEdit(true);

            let currentStatusData = {
                status: status,
                currentItemData: {
                    id: status.status,
                    name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, statusDetail.name),
                    no: statusDetail?.structure?.no,
                    color: statusDetail?.structure?.helpdesk?.color,
                    background: statusDetail?.structure?.helpdesk?.background
                }
            };

            if (ticket.affiliationProject !== selectedProject.id) {
                let customerLabel = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    statusDetail.viewForCustomer
                );
                currentStatusData.currentItemData.color = statusDetail?.structure?.customer?.color;
                currentStatusData.currentItemData.background =
                    statusDetail?.structure.customer?.background;
                if (!Utils.isEmptyString(customerLabel)) {
                    currentStatusData.currentItemData.name = customerLabel;
                }
            }
            setStatusOfTicket({ ...currentStatusData });
            setMailDefaultData(prev => {
                return {
                    ...prev,
                    status: currentStatusData
                }
            })

            // Update status of currentPanelInitData
            if (!Utils.isEmptyObject(currentPanelInitData)) {
                let newCurrentPanelInitData = cloneDeep(currentPanelInitData);
                newCurrentPanelInitData.ticketStatus = currentStatusData.currentItemData;
                if (isFromEditTicket) {
                    newCurrentPanelInitData.formData = {};
                }
                setCurrentPanelInitData(newCurrentPanelInitData);
            }
        }

        /**set value assignment field value into component */
        // const personInCharge = Utils.convertJSONDataToObject(detailTicket?.personInCharge);
        // const personInChargeInfo = Utils.convertJSONDataToObject(detailTicket?.personInChargeInfo);

        /**set field list data info */
        if (ticketDetailResult?.fieldListData) {
            let listField = Utils.convertJSONDataToObject(ticketDetailResult?.fieldListData);
            // console.log('namnhdebug listField', listField)
            //filter field is active
            if (formDetailObject.definition !== Constant.FORM_DEFINITION.SYSTEM) {
                listField = listField?.filter(field => {
                    if (
                        field.definition === Constant.FORM_DEFINITION.SYSTEM ||
                        field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                    ) {
                        return true;
                    }
                    const usingProjectOfField = Utils.convertJSONDataToObject(field?.usingProjects);
                    if (Utils.isEmptyArray(usingProjectOfField)) {
                        return false;
                    } else {
                        return field?.usingProjects?.includes(formDetailObject.affiliationProject);
                    }
                });
            }
            
            if (
                selectedProject.id !== ticket.affiliationProject &&
                (currentUserDetail?.id === ticket.customer ||
                    selectedProject.id === ticket.customer)
            ) {
              
                listField = listField.filter(x => Number(x.publicForCustomer) !== Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW);
                const listFieldPublicForCustomer = listField.filter(
                    field => field.publicForCustomer == Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER
                );
                if (!Utils.isEmptyArray(listFieldPublicForCustomer)) {
                    listField = Array.from(listField, field => {
                        if (Number(field.publicForCustomer) === Constant.SETTING_FORM_DEFAULT.READ_ONLY) {
                            field.structure.required = false;
                        }
                        return field;
                    });
                }
            }

            if (selectedProject.id === ticket.affiliationProject) {
                listField = Array.from(listField, x => {
                    x.publicForCustomer = Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER;
                    return x;
                });
            }

            if (!Utils.isEmptyObject(ticketDetailResult?.corporationOriginData)) {
                ticket.corporationOriginName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, ticketDetailResult?.corporationOriginData?.name);
            }

            let fieldListDataForEditTicket = [];
            listField.forEach(fieldData => {
                let fieldDataTmp = {
                    ...fieldData,
                    defaultValue:
                        fieldData.type === Constant.FORM_TYPE.FIELD_TAG
                            ? fieldData.defaultValue
                            : fieldData.value
                };
                if (
                    Utils.isAnonymousQAWaitingTicket(ticket) &&  ticket.affiliationProject === selectedProject.id
                ) {
                    fieldDataTmp.structure.publicForCustomer = Constant.SETTING_FORM_DEFAULT.READ_ONLY
                } else if (
                    [Constant.TICKET_TYPE.BROADCAST_PARENT, Constant.TICKET_TYPE.BROADCAST_CHILD].includes(ticket.ticketType) &&
                    fieldDataTmp.sysField === Constant.SYS_FIELD.ATTACHMENTS &&
                    ticket.affiliationProject !== selectedProject.id
                ) {
                    fieldDataTmp.structure.publicForCustomer = Constant.SETTING_FORM_DEFAULT.READ_ONLY
                }
                else {
                    fieldDataTmp.structure.publicForCustomer = Number(fieldData.publicForCustomer)
                }

                fieldListDataForEditTicket.push(fieldDataTmp);
            });

           const fieldsValidateInForm = fieldListDataForEditTicket.filter(
               fieldData =>
                   fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW ||
                   fieldData.sysField === Constant.SYS_FIELD.PERSON_IN_CHARGE
           );
            setFieldListDefaultData(fieldsValidateInForm);
            ticket.listField = listField;
        }

        const timeHasPassed = Utils.getTimeToDateNow(createAt);
        ticket.timeHasPassed = timeHasPassed;

        let ticketOutline = ticket.outline ? Utils.convertJSONDataToObject(ticket.outline)?.jp : '';
        ticket.ticketOutline = ticketOutline;

        if (ticket?.listTicketChild) {
            if (!Utils.isEmptyArray(Utils.convertJSONDataToObject(ticket?.listTicketChild))) {
                setListTicketChild([...Utils.convertJSONDataToObject(ticket?.listTicketChild)]);
            }
        }

        ticket = {
            ...ticket,
            deliverInfo: ticket.deliverInfo ? Utils.convertJSONDataToObject(ticket.deliverInfo) : {}
        }
        let tempEmailTicketList = [cloneDeep(ticket)]
        if (ticket.listTicketEmailChild) {
            let listTicketEmailChild = cloneDeep(ticket.listTicketEmailChild);
            let replyTicketList = Utils.convertJSONDataToObject(listTicketEmailChild);
            if (replyTicketList.length > 0) {
                tempEmailTicketList = [...tempEmailTicketList, ...replyTicketList];
            }
            // setReplyTicketList(listTicketEmailChild)
        }
        setEmailTicketList(tempEmailTicketList);
        const emailPageIsUpdated = tempEmailTicketList[currentPage - 1];
        if (emailPageIsUpdated) {
            const fileValue = emailPageIsUpdated?.listField?.find(
                i => i?.sysField === Constant.SYS_FIELD.ATTACHMENTS
            )?.value;
            if (fileValue) {
                setFileUpdatedList(fileValue);
            }
        }

           // Check corporationOrigin deleted
           if (
               !Utils.isEmptyObject(ticketDetailResult?.corporationOriginData) &&
               ticketDetailResult.corporationOriginData.active ===
                   Constant.CORPORATION_ACTIVE.DELETED 
           ) {
               setIsDisableEdit(true);
           }

        // For assignee current
        if (ticket?.personInChargeInfo?.avatar) {
            let avatarData = await Storage.get(ticket?.personInChargeInfo?.avatar);
            ticket.personInChargeInfo = {
                ...ticket.personInChargeInfo,
                avatar: avatarData
            }
        }

        let bookmarkData = Utils.convertJSONDataToObject(ticket?.bookmarkInfo)
        ticket.privateBookmarkData = bookmarkData.privateBookmarkData
        ticket.shareBookmarkData = bookmarkData.shareBookmarkData
        ticket.totalPrivateBookmark = bookmarkData.totalPrivateBookmark
        ticket.isBookmarkedDefaultBookmark = bookmarkData.isBookmarkedDefaultBookmark
        ticket.bookmarkListText = bookmarkData.bookmarkListText
        delete ticket.bookmarkInfo

        // set origin ticket
        setDetailTicket(ticket);
        setFormDetail(Utils.convertJSONDataToObject(ticketDetailResult.formDetail));
        const assigneeData = !Utils.isEmptyObject(ticket?.personInChargeInfo)
            ? {
                  ...ticket?.personInChargeInfo,
                  assigneeIcon: ticket?.personInChargeInfo?.shortName,
                  assigneeFullName: ticket?.personInChargeInfo?.fullName
              }
            : {
                  id: Constant.OPTION_UNASSIGNEE.KEY,
                  fullName: Constant.OPTION_UNASSIGNEE.TEXT
              };
        setCurrentAssigneeUserData(assigneeData);
        setMailDefaultData(prev => {
            return {
                ...prev,
                assignee: assigneeData
            };
        });

        removePanelInitData(props?.panelId, props?.tabId, panelInitData, setPanelInitData);
        setCurrentPage(tempEmailTicketList.length);
        setIsTriggerReloadCurrentTicket(true)
        setIsSoftDelete(!Utils.isEmptyString(ticket.deletedAt))
        setIsLoading(false);
        return {ticketDetail: ticket, totalPages: tempEmailTicketList.length, emailTickets: tempEmailTicketList};
    };

    const initProjectEmailSettingData = async () => {
        let paramsGetEmailSetting = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_PROJECT_EMAIL_SETTING,
            projectId: selectedProject.id,
            corporationId: corporationDetail.id,
            sugguestProjectMail: true
        };

        let emailSettingData = await getPublicAPI(props?.API, paramsGetEmailSetting)
        if (emailSettingData.success) {
            const { projectDetail, suggestList } = Utils.convertJSONDataToObject(emailSettingData.payload);
            const mailSetting = projectDetail?.mailSetting ? Utils.convertJSONDataToObject(projectDetail?.mailSetting) : {};

            setProjectMailSetting(mailSetting)
            setListSuggestSearchEmail([...suggestList]);
        }
    }


    const handleSubmitButton = async (formData) => {
        let isReplyTicket = !!replyToEmailTicket;

        let isEditCurrentTicket = currentTicketIsEdited();

        let isEditOriginTicket = isEdited;

        setIsLoading(true)
        setIsSelectDeliver(false);
        
        if (isReplyTicket) {
            const currentFieldSubject = replyDefaultData.find(f => f.sysField === Constant.SYS_FIELD.MAIL_SUBJECT)
            const submitFormData = getValuesReplyTicket();
            let originSubjectValue = getOriginEmailSubjectValue(emailTicketList, 'Re: ');

            const prefixSubject = 'Re: ';
            if (originSubjectValue?.substring(0, prefixSubject.length) !== prefixSubject) {
                originSubjectValue = prefixSubject + originSubjectValue;
            }

            const isChangedSubjectValue = currentFieldSubject ? submitFormData[currentFieldSubject.id] !== originSubjectValue : false
            
            if (isChangedSubjectValue && replyDeliverStatus === true) {
                const fieldListData = [...replyDefaultData, ...fieldListDefaultData].map(f => ({...f,fieldId: f.id}))
                await handleCreateNewTicketWhenChangedSubjectAndDelivered(submitFormData, fieldListData, fileReplyUploadList);
                return;
            };

            await handleSubmitCreateReplyTicket(isEditOriginTicket);

        } else if (isEditCurrentTicket) {
            const currentFieldSubject = currentTicketFields.find(f => f.sysField === Constant.SYS_FIELD.MAIL_SUBJECT)
            const originSubjectValue = getOriginEmailSubjectValue(emailTicketList, 'Re: ')

            const isChangedSubjectValue = currentFieldSubject ? currentMailSubject !== originSubjectValue : false

            const fieldListData = [...currentTicketFields, ...fieldListDefaultData].map(f => ({...f,fieldId: f.id}));

            if (isChangedSubjectValue && currentTicketDeliverStatus === true) {
                let submitData = {}
                let fileListUploaded = []

                for (let field of fieldListData) {
                    if (field.sysField === Constant.SYS_FIELD.MAIL_SUBJECT) {
                        submitData[field.id] = currentMailSubject
                    }
                    if (field.sysField === Constant.SYS_FIELD.MAIL_BODY) {
                        submitData[field.id] = currentMailBody.value
                    }
                    if (field.sysField === Constant.SYS_FIELD.ATTACHMENTS) {
                        submitData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME] = await handleGetUploadFileList(fileUploadList, fileUpdatedList, fileDeletedList)
                        fileListUploaded = field.value
                    }
                    continue;
                }

                let page = currentPage > emailTicketList.length ? emailTicketList.length : currentPage
                let currentEmailTicket = emailTicketList[page - 1];
                const deleteOldTicketId = currentEmailTicket.id;

                await handleCreateNewTicketWhenChangedSubjectAndDelivered(submitData, fieldListData, fileUploadList, fileListUploaded, deleteOldTicketId);
                return;
            } else {
                await handleSubmitUpdateCurrentTicket(fieldListData, currentTicketDeliverStatus, fileUploadList, fileDeletedList, isEditOriginTicket);
            }
        }

        if (!isEditOriginTicket) return;
        // update origin ticket
        await handleSubmitOriginTicket(formData);
    };
    
    const saveAndCancel = async e => {
        let formData = getValuesEditTicket();
        await handleSubmitButton(formData)
        // await handleSubmitOriginTicket(formData, false);
        // handleResetFormData()
    };

    const handleSubmitOriginTicket = async (formData) => {
        const isEditDraftStatus = false;
        const fields = Utils.getEditTicketData(formData, fieldListDefaultData);

        const updateData = {
            id: detailTicket.id,
            affiliationOrganization: detailTicket.affiliationOrganization
        }
        const editedFieldValue = Utils.getFieldsValueEdited(formData, fields, mapDataIdToId);

        setIsLoading(true);
        const fieldEdited = currentTabData?.listFieldEdited || listFieldEdited;
        
        const args = {
            ...argsAll,
            listFieldEdited: fieldEdited,
            setIsOpenPopupEditError: setIsOpenPopupTicketMsg
        };

        const updateResult = await submitUpdateTicket(
            props?.API,
            updateData,
            setIsLoading,
            setIsDisplayEditTicket,
            fileUploadList,
            fileUpdatedList,
            setFileUploading,
            setFileUploadList,
            detailTicket,
            fieldListDefaultData,
            formData,
            currentUserDetail,
            editedFieldValue,
            mapDataIdToId,
            isEditDraftStatus,
            args
        );

        if (updateResult?.isConfirm){
            return
        }
        setTriggerReloadTicket(Date.now().toString());

        setIsLoading(false);
        setFileUploadList([]);

        // reset submitted listFieldEdited
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'listFieldEdited', []);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        setIsEdited(false);
        setListFieldEdited([]);

        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        
        enqueueSnackbar(buildSnackbarMessage('MSG-CM-SAVE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    } 

    const onclickReplyTicket = async () => {
        let currentContentTicket = {...emailTicketList[currentPage - 1]};
        openReplyEmail(currentContentTicket);
    }

    const openReplyEmail = (currentContentTicket, triggerData = {}) => {
        let toAddress = [];
        let ccAddress = [];
        let bccAddress = [];
        
        if (!Utils.isEmptyObject(projectMailSetting)) {
            let mailSettingCcAddress = projectMailSetting.ccEmailAddressList.filter(item => !!item)
            let mailSettingBccAddress = projectMailSetting.bccEmailAddressList.filter(item => !!item)
            ccAddress = mailSettingCcAddress;
            bccAddress = mailSettingBccAddress;
        }

        let metaData = Utils.isJson(currentContentTicket?.metaData) ? Utils.convertJSONDataToObject(currentContentTicket?.metaData) :  currentContentTicket?.metaData;
        let metaDataFromValue = metaData?.emailOriginalData?.from?.value;
        // console.log('--- metaData', metaData)
        // console.log('--- metaData?.emailOriginalData', metaData?.emailOriginalData)

        if (metaDataFromValue && metaDataFromValue[0]) {
            let fromAddress = {
                id:  'new_' +  Date.now(),
                userId:  'new_' +  Date.now(),
                name: metaDataFromValue[0]?.name ? metaDataFromValue[0]?.name : '' ,
                mail: metaDataFromValue[0].address,
            };
            toAddress.push(fromAddress);
        }
        let listField = currentContentTicket?.listField;
        let tmpReplyDefaultData = [];
        listField.map(field => {
            let cloneField = {...field};
            switch (field.sysField) {
                case Constant.SYS_FIELD.TO:
                    if(triggerData && triggerData?.isOriginTicket) {
                        if(!Utils.isEmptyArray(cloneField?.value)) {
                            // Open reply from customer chatthread of origin ticket
                            toAddress.push(...cloneField?.value);

                            //

                        }
                    } else {
                        // remove my self
                        // let toValue = [...cloneField?.value];
                        // let toValueUnique = toValue.filter(to => to.projectId !== selectedProject?.id);
                        // ccAddress = [...ccAddress, ...toValueUnique];
                    }
                    tmpReplyDefaultData.push(cloneField);
                    break;
                case Constant.SYS_FIELD.CC:
                    if (!Utils.isEmptyArray(field?.value)) {
                        if(triggerData && triggerData?.isOriginTicket) {
                            // Open reply from customer chatthread of origin ticket
                            ccAddress = [...field?.value];
                        }else {
                            ccAddress = [...ccAddress, ...field?.value];
                        }
                    }
                    tmpReplyDefaultData.push(cloneField);
                    break;
                case Constant.SYS_FIELD.BCC:
                    if (!Utils.isEmptyArray(field?.value)) {
                        if(triggerData && triggerData?.isOriginTicket) {
                            // Open reply from customer chatthread of origin ticket
                            bccAddress = [...field?.value];
                        }else {
                            bccAddress = [...ccAddress, ...field?.value];
                        }
                    }
                    tmpReplyDefaultData.push(cloneField);
                    break;

                case Constant.SYS_FIELD.MAIL_BODY:
                    let bodyData = {...cloneField};
                    if(triggerData && triggerData?.defaultBody) {
                        bodyData = {...bodyData, defaultValue: triggerData?.defaultBody};
                    }
                    tmpReplyDefaultData.push(bodyData);
                    break;
                case Constant.SYS_FIELD.MAIL_SUBJECT:
                case Constant.SYS_FIELD.ATTACHMENTS:
                    tmpReplyDefaultData.push(cloneField);
                    break;
            
                default:
                    break;
            }
        })

        // Set default value to reply mail
        // Open reply from customer chatthread of origin ticket
        if(!Utils.isEmptyObject(triggerData)) {
            currentContentTicket.listField = tmpReplyDefaultData;
        }

        ccAddress = removeDuplicateInArray(ccAddress)
        bccAddress = removeDuplicateInArray(bccAddress)

        registerReplyTicket('fileUploadList');
        registerReplyTicket('attachments');

        setReplyDefaultData(tmpReplyDefaultData);
        setCcEmailAddressList(ccAddress)
        setBccEmailAddressList(bccAddress)
        setToEmailAddressList(toAddress)
        setReplyToEmailTicket(currentContentTicket);
    }

    const removeDuplicateInArray = (emailList) => {
        const uniqueProjects = emailList.filter((item, index, self) => 
            !item.projectId || 
            index === self.findIndex((t) => t.projectId === item.projectId)
        );

        const uniqueData = uniqueProjects.filter((item, index, self) => 
            !item.mail || 
            index === self.findIndex((t) => t.mail === item.mail)
        );
        return uniqueData;
    }

    const handleSubmitUpdateCurrentTicket = async (
        fieldListData,
        isTicketReplyDeliver = false,
        fileListUpload = [],
        fileListUploaded = [],
        isEditOriginTicket
    ) => {
        try {
            setIsLoading(true);

            const currentEmailTicket = emailTicketList[currentPage - 1]
            const updateData = {
                id: currentEmailTicket.id,
                affiliationOrganization: detailTicket.affiliationOrganization
            }
            let mappingDataIdToIdObj = currentEmailTicket?.mappingDataIdToIdObj || {}
            let isUpdateDraft = false
    
            let formData = {}
            let editedFieldValue = {}
            let listEditedField = []
    
            for(let field of fieldListData) {
                if (field.sysField === Constant.SYS_FIELD.TO) {
                    formData[field.id] = toEmailAddressList
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: toEmailAddressList})
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.CC) {
                    formData[field.id] = ccEmailAddressList
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: ccEmailAddressList})
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.BCC) {
                    formData[field.id] = bccEmailAddressList
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: bccEmailAddressList})
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.MAIL_SUBJECT) {
                    formData[field.id] = currentMailSubject
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: currentMailSubject})
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.MAIL_BODY) {
                    formData[field.id] = currentMailBody
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = {value: currentMailBody.value}
                        }
                    }
                    listEditedField.push(field.id)
                }
                if (field.sysField === Constant.SYS_FIELD.ATTACHMENTS) {
                    formData[field.id] = currentMailSubject
                    for (const [key, value] of Object.entries(mappingDataIdToIdObj)) {
                        if (key === field.id) {
                            editedFieldValue[value] = JSON.stringify({value: [...fileListUpload, ...fileListUploaded]})
                        }
                    }
                    listEditedField.push(field.id)
                }
            }
            let submitArgs = {
                ...argsAll,
                setIsOpenPopupEditError: () => {},
                setIsLoading: () => {},
                setForceEditTicketObject: () => {},
                setIsMe: () => {},
                isTicketReplyDeliver: isTicketReplyDeliver,
                isEditOriginTicket: isEditOriginTicket,
                listFieldEdited: listEditedField,
            }
    
            const updateResult = await submitUpdateTicket(
                props?.API,
                updateData,
                setIsLoading,
                setIsDisplayEditTicket,
                fileListUpload,
                fileListUploaded,
                setFileUploading,
                setFileUploadList,
                currentEmailTicket,
                fieldListDefaultData,
                formData,
                currentUserDetail,
                editedFieldValue,
                mappingDataIdToIdObj,
                isUpdateDraft,
                submitArgs
            );
    
            if (updateResult?.isConfirm){
                return
            }
            setTriggerReloadTicket(Date.now().toString());
            
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'listFieldEdited', []);

            reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST});
            reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD});

            setListFieldEdited([]);
            setFileUploadList([]);
            setFileDeletedList([]);

            setDisplayMode(Constant.DISPLAY_MODE.VIEW);

            setTimeout(() => {
                setIsLoading(false);
                enqueueSnackbar(
                    buildSnackbarMessage(isTicketReplyDeliver ? 'MSG-CM-SEND-TICKET-SUCCESS' : 'MSG-CM-SAVE-CONTENT-SUCCESSFULLY'),
                    { variant: 'success', autoHideDuration: 3000 }
                );
            }, 2000);

        } catch (error) {
            console.log('handleSubmitUpdateCurrentTicket error >>>', error)
        }
    }

    const handleSubmitCreateReplyTicket = async (isEditOriginTicket) => {
        setIsLoading(true);
        let formData = getValuesReplyTicket();
        let replyResult = await handleCreateReplyEmailTicket(
                toEmailAddressList,
                ccEmailAddressList,
                bccEmailAddressList,
                replyDeliverStatus,
                formDetail,
                formData,
                replyDefaultData,
                fileReplyUploadList,
                corporationDetail,
                currentUserDetail,
                selectedProject,
                replyToEmailTicket
            )

            if (!replyResult) {

            }

        if (!isEditOriginTicket) {
            setTriggerReloadTicket(Date.now().toString());
        }

        reloadTicketListByPanelType({panelType: getTicketListType() ? getTicketListType() : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST });
        
        // reset reply data
        clearErrorReplyTicket();
        onClickCancelReplyTicket();
        setTimeout(() => {
            enqueueSnackbar(
                buildSnackbarMessage(replyDeliverStatus ? 'MSG-CM-SEND-TICKET-SUCCESS' : 'MSG-CM-SAVE-CONTENT-SUCCESSFULLY'),
                { variant: 'success', autoHideDuration: 3000 }
            );
        }, 2000)
    }

    const handleCreateNewTicketWhenChangedSubjectAndDelivered = async (submitFormData, fieldListData, fileListUpload = [], fileListUploaded = [], deleteOldTicketId) => {
        try {
            const newTicketEmail = await createEmailTicketHandler(
                submitFormData,
                currentUserDetail,
                null,
                null,
                null,
                corporationDetail,
                formDetail.id,
                fieldListData,
                {
                    setIsErrorSelected: () => {},
                    toEmailAddressList: toEmailAddressList,
                    ccEmailAddressList: ccEmailAddressList,
                    bccEmailAddressList: bccEmailAddressList,
                    setIsLoading: setIsLoading,
                    fieldListData: fieldListData,
                    setFiledListData: setFieldListDefaultData,
                    setErrorMessageHeader: setErrorMessageHeader,
                    setFileUploading: () => {},
                    fileUploadList: fileListUpload,
                    fileUpdatedList: fileListUploaded,
                    projectInuseDetail: selectedProject,
                    selectedForm: formDetail.id,
                    selectedAssigneeUserId: !Utils.isEmptyObject(newAssigneeData) ? newAssigneeData.id : '',
                    API: props?.API,
                    setIsOpenModalReloadPage: () => {},
                    userDetail: currentUserDetail,
                    statusNo: statusNo,
                    enqueueSnackbar: enqueueSnackbar,
                    isUpdatePanelAfterCreatedTicket: false,
                    deleteOldTicketId: deleteOldTicketId
                },
            )
            if (newTicketEmail) {
                // add new tab new ticket
                const panelHelpdeskDetail = panelList.find(p => p.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL)
                addNewPanel({
                    type: Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                    tabId: newTicketEmail.id,
                    props: {
                        API: {},
                        panelId: panelInitData[0].id,
                        ticketId: newTicketEmail.id,
                        componentName: Constant.COMPONENT_NAME.TICKET_LIST,
                        ticketListType: Constant.TYPE_GET_TICKET_LIST.HELPDESK,
                        panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST,
                    },
                    ticketId: newTicketEmail.id,
                    ticketOutline: newTicketEmail?.outline,
                    isDraft: false,
                    isEmailTicket: true,
                    isTicketDeleted: false,
                    newPanelId: panelHelpdeskDetail.id || Date.now().toString(),
                    isOpenChat: true,
                    startRelatePanelFromPanelId: panelInitData[0].id,
                });

                // add new tab chat
                setTimeout(() => {
                    const propsClone = cloneDeep(props);
                    delete propsClone?.panelId;
                    addNewPanel({
                        type: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
                        tabId: newTicketEmail.id,
                        currentPanelId: panelHelpdeskDetail.id || Date.now().toString(),
                        isTicketDeleted: false,
                        isShowAllChatPost: false,
                        props: propsClone,
                        ticketOutline: newTicketEmail?.outline,
                        ticketId: newTicketEmail.id,
                        openRelatePanelType: Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                        isEmailTicket: true
                    });
                }, 2000);

                reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST});
                reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH});
            }
        } catch (error) {
            console.log('createEmailTicketHandler error >>>', error)
        }
    }

    const onClickCancelReplyTicket = () => {
        if (!!replyToEmailTicket) {
            setReplyToEmailTicket(null);
            setCcEmailAddressList([])
            setBccEmailAddressList([])
            setToEmailAddressList([])
            setFileUploadList([])
            setReplyDeliverStatus(false);
            setReplyDefaultData([])
            resetValuesReplyTicket();
            setFileReplyUploadList([]);
            setReplyConfirm({...replyConfirm, isOpen: false})
            triggerEnableBtnSaveTicket();
            setCurrentTicketDeliverStatus(false)
            setIsReplyEditData(false)
        } else { // isEditedCurrentTicket
            setIsEditedCurrentTicket(false)
            setFileUploadList([])
            setIsTriggerReloadCurrentTicket(true)
            setReplyConfirm({...replyConfirm, isOpen: false})
        }
    }

    const getTicketListType = () => {
        return getPanelType() === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
        ? Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        : Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
    };
    
    const handleGoToLatestEmail = () => {
        setCurrentPage(emailTicketList.length)
    }

    const handleNextEmail = () => {
        if (currentPage < emailTicketList.length) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevEmail = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleSoftDeleteTicket = () => {
        setAnchorShowMoreActionsPopover(null);
        setIsOpenPopupSoftDelete(true);
    }

    const submitSoftDelete = async () => {
        const deletedAt = isSoftDelete
            ? null
            : new Date().toISOString();
        setIsLoading(true);
        if (isSoftDelete) {
            setIsShowDialogRestoreTicket(false);
        }
        let result = await submitSoftDeleteTicket(props?.API, detailTicket, deletedAt, currentUserDetail, argsAll);
        if(result?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            setIsLoading(false);
            setIsOpenModalReloadPage(true);
            return;
        }

        await getTicketDetail(detailTicket.id, false);

        setIsLoading(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        reloadPanelAfterSoftDeleteTicketByPanelType({
            panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            id: detailTicket.id
        });

        // reload escalate ticket
        const customerTicketDetailPanel = panelList.find(p => p.type === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL);
        if (customerTicketDetailPanel) {
            let updatedTabList = [...customerTicketDetailPanel.tabList];
            if (!Utils.isEmptyArray(updatedTabList)) {
                for (let i = 0; i < updatedTabList.length; i++) {
                    const tab = updatedTabList[i];
                    
                    const isTabCreateNew = tab.id.includes('QA_NEW_TICKET_TAB');
                    if (isTabCreateNew) {
                        const parentTicketIdMatch = tab.id.match(/req_[a-z0-9-]+/);
                        const parentTicketId = parentTicketIdMatch ? parentTicketIdMatch[0] : null;
                        if (parentTicketId && parentTicketId === detailTicket.id) {
                            closePanelTab({
                                event: null,
                                panelType: Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL, // customer_ticket_detail
                                panelId: customerTicketDetailPanel.id,
                                tabId: tab.id
                            });
                        }
                    }
                }
            }
        }

        let msgKeyDeleteSuccess = 'MSG-CM-RESTORE-CONTENT-SUCCESSFULLY';
        if (isSoftDelete) {
            setIsSoftDelete(false);
            reloadPage();
        } else {
            msgKeyDeleteSuccess = 'MSG-CM-DELETE-CONTENT-SUCCESSFULLY';
            setIsSoftDelete(true);
        }

        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        setAnchorShowMoreActionsPopover(null);

        enqueueSnackbar(buildSnackbarMessage(msgKeyDeleteSuccess), {
            variant: 'success',
            autoHideDuration: 3000
        });
    };

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };

    const reloadPage = () => {
        setTriggerReloadTicket(Date.now().toString());
    }

    const onClickCloseConfirmDialog = () => {
        setIsShowDialogRestoreTicket(false);
        setIsConfirmDialogObj(false);
    }

    const onClickOkConfirmDialog = async () => {
        setIsConfirmDialogObj(false);
        await handleDeleteTicket();
    }

    const handleDeleteTicket = async () => {
        setIsLoading(true);
        let ticketId = detailTicket.id;
        let {status: currentStatusTicket} = await checkDetailTicket(props?.API, ticketId);
        if (currentStatusTicket === Constant.TICKET_DELETED_STATUS.REMOVED) {
            setIsLoading(false);
            setIsOpenPopupTicketError(true);
            return;
        }
        if (currentStatusTicket === Constant.TICKET_DELETED_STATUS.INUSED || currentStatusTicket === Constant.TICKET_DELETED_STATUS.ARCHIVED) {
            setIsLoading(false);
            setIsOpenPopupTicketMsg(true);
            return;
        }
        
        let removeOldTicket = await deleteAllTicketData(props?.API, {
            ticketId: ticketId
        });
        if (!removeOldTicket) {
            setIsLoading(false);
            enqueueSnackbar(buildSnackbarMessage('COMMSG002'), {
                variant: 'error',
                autoHideDuration: 3000
            });
            return;
        }

        if(isTicketCountNumber(detailTicket.ticketType) && detailTicket.affiliationOrganization === corporationDetail.id) {
            let corpDetailResult = await getCorporationDetailByCorporationDomain(props?.API, corporationDetail.organizationDomain);
            setCorporationDetail(corpDetailResult);
        }

        const chatThreadPanelType =
            props.ticketListType === 'helpdesk'
            || props.panelType === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
        
        const chatPanel = panelList.find(panel => panel.type === chatThreadPanelType);

        if (!Utils.isEmptyObject(chatPanel)) {
            closePanelTab({
                event: null,
                isCloseMulti: true,
                closeList: [
                    {
                        panelType: chatThreadPanelType,
                        panelId: chatPanel.id,
                        tabId:
                            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                                ? props.ticketId
                                : props.tabId
                    },
                    {
                        panelType: getPanelType(),
                        panelId: props.panelId,
                        tabId:
                            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                                ? props.ticketId
                                : props.tabId
                    }
                ]
            });
        } else {
            closePanelTab({
                event: null,
                panelType: getPanelType(),
                panelId: props.panelId,
                tabId:
                    detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
                        ? props.ticketId
                        : props.tabId
            });
        }

        setIsLoading(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        
        enqueueSnackbar(buildSnackbarMessage('MSG-CM-COMPLETE-DELETE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });

        hideLoadingMouse();
    }

    const handleReloadComponent = () => {
        setIsOpenPopupTicketError(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        closePanelTab({
            event: null,
            panelType: getPanelType(),
            panelId: props.panelId,
            tabId: props.tabId
        });
        closePanelTab({
            event: null,
            panelType:
                props.ticketListType === 'helpdesk'
                    ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                    : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD,
            panelId: props.panelId,
            tabId: props.tabId
        });
    }

    const handleArchiveTicketEmail = async () => {
        let newArgsAll = {
            API: props?.API,
            setIsLoading,
            corporationDetail,
            selectedProject,
            currentUserDetail,
            detailTicket,
            formDetail,
            setIsOpenModalReloadPage,
            setReloadChatThread,
            reloadChatThread
        }
        await handleArchiveTicket(
            props?.API,
            detailTicket,
            setDetailTicket,
            reloadTicketListByPanelType,
            getTicketListType(),
            setTriggerReloadTicket,
            currentUserDetail,
            setTriggerReloadMenu,
            newArgsAll
        )
    }

    const handleAddPanelChatThread = () => {
        let openRelatePanelType = false;
        if (props.isOpenChat && props) {
            openRelatePanelType = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
        }
        addNewPanel({
            type: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            tabId: props.ticketId,
            ticketId: props.ticketId,
            props,
            ticketOutline: detailTicket?.ticketOutline,
            isTicketDeleted: !Utils.isEmptyString(detailTicket?.deletedAt) ? true : false,
            isShowAllChatPost: false,
            openRelatePanelType: openRelatePanelType
        });
        setAnchorShowMoreActionsPopover(null);
    }
    
    const setShowButtonEditTicket = (value) => {
        triggerEnableBtnSaveTicket()
    }
    
    const isDisableBtnSaveTicket = () => {
        // show button send
        if (replyToEmailTicket) {
            if (toEmailAddressList.length === 0) return true;

            let toList = processEmailAddressList(toEmailAddressList);
            if (Utils.isEmptyArray(toList)) return true;

            // TODO: check body data => need form provider
            let formData = getValuesReplyTicket();
            let bodyField = replyDefaultData.find(reply => reply.sysField === Constant.SYS_FIELD.MAIL_BODY);
            if (bodyField) {
                let bodyData = formData[bodyField.id] ? formData[bodyField.id] : ''
                let bodyDataText = getRichTextFieldContent(bodyData);
                if (!bodyDataText || bodyDataText === '""') {
                    return true;
                }
            }

            if (!Utils.isEmptyObject(errorReplyTicket)) return true;
    
            return false;
        }

        // check has edit current ticket
        if (currentTicketIsEdited()){
            return false;
        }

        // return false
        if (!isInputAllFieldRequiredWhenEditTicket(fieldListDefaultData, [...fileUploadList, ...fileUpdatedList], getValuesEditTicket)) {
            return true;
        }
        return !isEdited;
    }

    const triggerEnableBtnSaveTicket = () => {
        setIsDisableBtnSave(isDisableBtnSaveTicket());
    }

    const currentTicketIsEdited = () => {
        if (emailTicketList.length > 0) {
            let page = currentPage > emailTicketList.length ? emailTicketList.length : currentPage
            let currentEmailTicket = emailTicketList[page - 1];
            let isProjectEmail = currentEmailTicket?.projectOrigin === currentEmailTicket?.affiliationProject;
            if (
                currentEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY && 
                isProjectEmail && 
                currentEmailTicket.deliverInfo && 
                !currentEmailTicket.deliverInfo.status &&
                isEditedCurrentTicket
            ) {
                const isInvalid = Utils.isEmptyArray(toEmailAddressList) ||
                    (
                        toEmailAddressList.length === 1 &&
                        !!toEmailAddressList[0].projectId &&
                        toEmailAddressList[0].userList.every(item => !item.selected)
                    ) ||
                    !Utils.isEmptyString(currentMailBody?.error) ||
                    !Utils.isEmptyString(currentAttachmentError)
                
                return isInvalid ? false : true;
            }
            return false;
        }
        return false;
    }

    const handleResetFormData = () => {
        setToEmailAddressList(mailDefaultData.toEmailAddressList);
        setCcEmailAddressList(mailDefaultData.ccEmailAddressList);
        setBccEmailAddressList(mailDefaultData.bccEmailAddressList);
        setCurrentMailSubject(mailDefaultData.currentMailSubject);
        setCurrentMailBody(mailDefaultData.currentMailBody);
        setCurrentTicketDeliverStatus(mailDefaultData.currentTicketDeliverStatus);
        setFileUpdatedList(mailDefaultData.fileUpdatedList);
        setNewStatusData(mailDefaultData?.status?.currentItemData);
        setStatusOfTicket(prev => {
            return {
                ...prev,
                currentItemData: mailDefaultData?.status?.currentItemData
            };
        });
        setNewAssigneeData(mailDefaultData?.assignee);
        setCurrentAssigneeUserData(mailDefaultData?.assignee);
        // Clear all err
        clearErrors();
        setIsEdited(false);
        setIsEditedCurrentTicket(false);
        setListFieldEdited([]);
        setFileUploadList([]);
        setFileDeletedList([]);
        setIsSelectDeliver(false);
        setErrorMessageHeader('');
    };

    const handleClickBackToArrivalTicket = () => {
        setIsShowDialogBackToArrivalTicket(true)
    }

    const onClickOkConfirmDialogBackToArrival = async () => {
        setIsShowDialogBackToArrivalTicket(false);
        let newArgsAll = {
            API: props?.API,
            setIsLoading,
            enqueueSnackbar,
            setReloadChatThread,
            reloadChatThread,
        }
        await handleBackToArrivalTicket(props?.API,
            detailTicket,
            setDetailTicket,
            reloadTicketListByPanelType,
            getTicketListType(),
            setTriggerReloadTicket,
            currentUserDetail,
            setTriggerReloadMenu,
            setIsLoading,
            setIsOpenModalReloadPage,
            newArgsAll
        );
    }

    let metaData = Utils.isJson(detailTicket?.metaData) ? Utils.convertJSONDataToObject(detailTicket?.metaData) :  detailTicket?.metaData;
    let isRestoredFirstView = metaData?.isRestoredFirstView;
    
    
    const detailEmailPage = currentPage > emailTicketList.length ? emailTicketList.length : currentPage;
    const currentEmailTicket = !Utils.isEmptyArray(emailTicketList) && emailTicketList[detailEmailPage - 1] ? emailTicketList[detailEmailPage - 1] : {};
    const isCustomerOrDelivered = !!(
        currentEmailTicket?.projectOrigin !== currentEmailTicket?.affiliationProject ||
        currentEmailTicket?.ticketType === Constant.TICKET_TYPE.EMAIL ||
        (currentEmailTicket?.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY &&
            currentEmailTicket?.deliverInfo?.status)
    );
    let currentChatPostMsgId = '';

    useEffect(() => {
        if (
            props.triggerReload ||
            triggerReloadTicket ||
            triggerReLoadHelpdeskTicketDetail === props.ticketId
        ) {
            getTicketDetail(props.ticketId, false);
            setTriggerReLoadHelpdeskTicketDetail('');
        }
    }, [
        props.triggerReload,
        triggerReLoadHelpdeskTicketDetail,
        props.ticketId,
        triggerReloadTicket
    ]);

    const isDisplayButtonEditTicket = () => {
        return (
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
        );
    };

    const isDisplayButtonArchivedTicket = () => {
        if (
            selectedProject.id !== detailTicket.affiliationProject &&
            (currentUserDetail?.id === detailTicket.customer ||
                selectedProject.id === detailTicket.customer)
        ) {
            return false;
        }

        if (replyToEmailTicket) return false;

        return (
            selectedProject.id === detailTicket.affiliationProject &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            !detailTicket.deletedAt
        );
    };

    const isDisplayButtonCancelTicket = () => {
        return (
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            detailTicket.ticketType === Constant.TICKET_TYPE.EMAIL
        );
    };

    const isDisplayButtonSoftDeleteTicket = () => {
        return (
            [Constant.TICKET_TYPE.EMAIL].includes(detailTicket?.ticketType) &&
            selectedProject.id === detailTicket.affiliationProject &&
            !detailTicket.deletedAt &&
            !replyToEmailTicket
        );
    };

    const isDisplayButtonBackToArrival = () => {
        if (
            selectedProject.id !== detailTicket.affiliationProject &&
            (currentUserDetail?.id === detailTicket.customer ||
                selectedProject.id === detailTicket.customer)
        ) {
            return false;
        }

        if (replyToEmailTicket) return false;

        return (
            selectedProject.id === detailTicket.affiliationProject &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            !detailTicket.deletedAt
        );
    };

    const isDisplayButtonCluster = () => {
        if (isSoftDelete) return false;
        return (
            isDisplayButtonEditTicket() ||
            isDisplayButtonArchivedTicket() ||
            isDisplayButtonCancelTicket() ||
            isDisplayButtonSoftDeleteTicket()
        );
    };

    const isArchiveOrTrashView = useMemo(() => {
        return (
            (isDisplayButtonBackToArrival() &&
                getPanelType() !== Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL) ||
            (isSoftDelete &&
                isGeneralUserWithGuest &&
                !Utils.isDisabledTicketExternalWhenDeskServiceOff(detailTicket, corporationDetail))
        );
    }, [
        corporationDetail,
        detailTicket,
        getPanelType,
        isDisplayButtonBackToArrival,
        isGeneralUserWithGuest,
        isSoftDelete
    ]);

    useEffect(() => {
        if (emailTicketList.length) {
            const timeout = setTimeout(() => {
                let emailTicketListCloned = cloneDeep(emailTicketList);
                emailTicketListCloned[currentPage - 1]['mailFormData'] = {
                    toEmailAddressList,
                    ccEmailAddressList,
                    bccEmailAddressList,
                    currentMailSubject,
                    currentMailBody,
                    currentTicketDeliverStatus,
                    fileUploadList,
                    fileDeletedList,
                    fileUpdatedList,
                    displayMode,
                    isEdited,
                    isEditedCurrentTicket,
                    newStatusData,
                    newAssigneeData,
                    isSelectDeliver
                };
                if (!isEqual(emailTicketListCloned, emailTicketList)) {
                    setEmailTicketList(emailTicketListCloned)
                    setCurrentPanelInitData(prev => ({
                        ...prev,
                        emailTicketList: emailTicketListCloned
                    }))
                    updatePanelInitData(
                        props.panelId,
                        props.tabId,
                        panelInitData,
                        setPanelInitData,
                        'emailTicketList',
                        emailTicketListCloned
                    );
                    setIsTriggerReloadCurrentTicket(true);
                }
            }, 250);
            return () => clearTimeout(timeout);
        }

    }, [
        toEmailAddressList,
        ccEmailAddressList,
        bccEmailAddressList,
        currentMailSubject,
        currentMailBody,
        currentTicketDeliverStatus,
        fileUploadList,
        fileDeletedList,
        fileUpdatedList,
        displayMode,
        isEditedCurrentTicket,
        isEdited,
        newStatusData,
        newAssigneeData,
        isSelectDeliver
    ]);

    useEffect(() => {
        if (
            !Utils.isEmptyString(props?.targetTicketIdOfChatPost) &&
            !Utils.isEmptyArray(emailTicketList)
        ) {
            const targetTicketIdx = emailTicketList?.findIndex(
                emailTicket => emailTicket?.id === props?.targetTicketIdOfChatPost
            );
            if (targetTicketIdx !== -1) {
                setCurrentPage(targetTicketIdx + 1);
                delete props.targetTicketIdOfChatPost;
            }
        }
    }, [props?.targetTicketIdOfChatPost, emailTicketList]);

    if (currentEmailTicket?.id && detailTicket?.chatPostMessageData) {
        let chatPostMessageData = Utils.convertJSONDataToObject(detailTicket?.chatPostMessageData);
        if (!Utils.isEmptyObject(chatPostMessageData) && chatPostMessageData.hasOwnProperty(currentEmailTicket.id)) {
            currentChatPostMsgId = chatPostMessageData[currentEmailTicket.id];
        }
    }


    return (
        <div style={{ height: '100%' }}>
            {isLoading ? (
                <LoadingPanel isLoading={isLoading} />
            ) : (
                <div className="mainWrap addTicket-detail">
                    <div className="col2">
                        <DetailContentOnDemandControl
                            className="detail-ondemand-translation--boxed"
                            contentMode={displayMode}
                            contentId={emailTicketList?.[currentPage - 1]?.id}
                        />
                    </div>

                    {(displayMode === Constant.DISPLAY_MODE.EDIT ||
                        isArchiveOrTrashView ||
                        isCustomerOrDelivered ||
                        replyToEmailTicket) && (
                        <HeaderButton
                            panelId={props?.panelId}
                            detailTicket={detailTicket}
                            handleSoftDeleteTicket={handleSoftDeleteTicket}
                            selectedProject={selectedProject}
                            currentUserDetail={currentUserDetail}
                            corporationDetail={corporationDetail}
                            handleArchiveTicket={handleArchiveTicketEmail}
                            isSoftDelete={isSoftDelete}
                            isGeneralUserWithGuest={isGeneralUserWithGuest}
                            replyToEmailTicket={replyToEmailTicket}
                            setIsConfirmDialogObj={setIsConfirmDialogObj}
                            setIsShowDialogRestoreTicket={setIsShowDialogRestoreTicket}
                            handleSubmitEditTicket={() => warpSubmitEditTicket(handleSubmitButton)}
                            isDisableBtnSaveTicket={isDisableBtnSaveTicket}
                            onClickCancelReplyTicket={onClickCancelReplyTicket}
                            handleBackToArrivalTicket={handleClickBackToArrivalTicket}
                            currentTicketDeliverStatus={currentTicketDeliverStatus}
                            isEdited={isEdited}
                            isDisableBtnSave={isDisableBtnSave}
                            currentTicketIsEdited={currentTicketIsEdited}
                            triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                            setReplyConfirm={setReplyConfirm}
                            replyConfirm={replyConfirm}
                            isReplyEditData={isReplyEditData}
                            handleCloseTab={handleCloseTab}
                            isArchiveOrTrashView={isArchiveOrTrashView}
                            isDisplayButtonCluster={isDisplayButtonCluster}
                            isDisplayButtonSoftDeleteTicket={isDisplayButtonSoftDeleteTicket}
                            isDisplayButtonArchivedTicket={isDisplayButtonArchivedTicket}
                            getPanelType={getPanelType}
                            isDisplayButtonBackToArrival={isDisplayButtonBackToArrival}
                            isDisplayButtonEditTicket={isDisplayButtonEditTicket}
                            setDisplayPopupConfirmCancel={setDisplayPopupConfirmCancel}
                            setDisplayMode={setDisplayMode}
                            isEditedCurrentTicket={isEditedCurrentTicket}
                            isCustomerOrDelivered={isCustomerOrDelivered}
                            isSelectDeliver={isSelectDeliver}
                        />
                    )}

                    <div className="scrollBar-main change-bodR">
                        {isSoftDelete && (
                            <div className="form-addTicket">
                                <div className="alert-complete-delete-ticket">
                                    <p>
                                        {tr('本チケットは削除した日付から30日以内で復元可能です。')}
                                        <br />
                                        {moment(detailTicket.deletedAt)
                                            .add(30, 'days')
                                            .format('YYYY/MM/DD')}
                                        {tr('に自動的に完全削除されます。')}
                                    </p>
                                </div>
                            </div>
                        )}
                        {isRestoredFirstView && (
                            <div className="form-addTicket">
                                <div className="alert-complete-delete-ticket">
                                    <p>{tr('このメールチケットはゴミ箱から復元されました。')}</p>
                                </div>
                            </div>
                        )}

                        {!replyToEmailTicket && (
                            <PaginationButton
                                detailTicket={detailTicket}
                                handleNextEmail={handleNextEmail}
                                handlePrevEmail={handlePrevEmail}
                                handleGoToLatestEmail={handleGoToLatestEmail}
                                currentPage={currentPage}
                                totalPages={emailTicketList.length}
                                isLatestEmail={currentPage < emailTicketList.length}
                                handleAddPanelChatThread={handleAddPanelChatThread}
                                currentEmailTicket={
                                    emailTicketList ? emailTicketList[currentPage - 1] : null
                                }
                                isGeneralUser={isGeneralUser}
                                corporationDetail={corporationDetail}
                                selectedProject={selectedProject}
                                currentUserDetail={currentUserDetail}
                                reloadTicketListByPanelType={reloadTicketListByPanelType}
                                displayMode={displayMode}
                                setDisplayMode={setDisplayMode}
                                setAnchorShowMoreActionsPopover={setAnchorShowMoreActionsPopover}
                                isArchiveOrTrashView={isArchiveOrTrashView}
                                isCustomerOrDelivered={isCustomerOrDelivered}
                            />
                        )}

                        <FormProvider {...validateEditTicket}>
                            <ErrorMessageHeader message={errorMessageHeader} />
                            <OriginEmailAssignField
                                panelId={props?.panelId}
                                tabId={props?.tabId}
                                detailTicket={detailTicket}
                                fieldListDefaultData={fieldListDefaultData}
                                setNewAssignee={setNewAssignee}
                                newAssignee={newAssignee}
                                currentAssigneeUserData={currentAssigneeUserData}
                                setCurrentAssigneeUserData={setCurrentAssigneeUserData}
                                isEdited={isEdited}
                                setIsEdited={setIsEdited}
                                isEditTicket={isEditTicket}
                                setIsEditTicket={setIsEditTicket}
                                isMe={isMe}
                                setIsMe={setIsMe}
                                newAssigneeData={newAssigneeData}
                                setNewAssigneeData={setNewAssigneeData}
                                isDisableEdit={
                                    isCustomerOrDelivered || replyToEmailTicket
                                        ? isDisableEdit
                                        : isDisableEdit ||
                                          displayMode === Constant.DISPLAY_MODE.VIEW
                                }
                                triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                                listFieldEdited={listFieldEdited}
                                setListFieldEdited={setListFieldEdited}
                                setFlagReset={setFlagReset}
                                flagReset={flagReset}
                            />
                            <OriginStatusField
                                detailTicket={detailTicket}
                                selectedAssigneeUserId={newAssignee}
                                isDisableEdit={
                                    isCustomerOrDelivered || replyToEmailTicket
                                        ? isDisableEdit
                                        : isDisableEdit ||
                                          displayMode === Constant.DISPLAY_MODE.VIEW
                                }
                                API={props?.API}
                                setShowButtonEditTicket={setShowButtonEditTicket}
                                setNewStatusOfTicket={setNewStatusOfTicket}
                                setNewStatusData={setNewStatusData}
                                newStatusData={newStatusData}
                                listFieldEdited={listFieldEdited}
                                setOnChangeEdit={() => {}}
                                setListFieldEdited={setListFieldEdited}
                                statusDetail={statusOfTicket?.status}
                                isHelpDesk={isHelpDesk}
                                setStatusNo={setStatusNo}
                                currentPanelInitData={currentPanelInitData}
                                currentItemData={statusOfTicket?.currentItemData}
                                fieldListDefaultData={fieldListDefaultData}
                                setIsEdited={setIsEdited}
                                setFlagReset={setFlagReset}
                                flagReset={flagReset}
                            />
                        </FormProvider>

                        {/* Message ID */}
                        <div className="form-addTicket">
                            <div className="form-addTicket-label message-id-content">
                                {trI18n('LABEL-MESSAGE-ID')} :
                                <CopyIdElement
                                    key={`copy-msg-${currentChatPostMsgId}`}
                                    copyId={currentChatPostMsgId}
                                    messageShareLink={currentChatPostMsgId}
                                    isShow={true}
                                    title={trI18n('LABEL-CHATPOST-SHARELINK-TOOLTIP')}
                                    flagMessage={trI18n('MSG-COPY-SHARELINK')}
                                />
                                <span>{currentChatPostMsgId}</span>
                            </div>
                        </div>

                        {!Utils.isEmptyArray(listTicketChild) && isHelpDesk && (
                            <EscalationEmailTicket
                                props={props}
                                isHelpDesk={isHelpDesk}
                                listTicketChild={listTicketChild}
                                viewFromProjectOfEscalateTicket={viewFromProjectOfEscalateTicket}
                                addNewPanel={addNewPanel}
                            />
                        )}

                        {replyToEmailTicket ? (
                            <ReplyEmailTicketForm
                                originTicket={detailTicket}
                                currentEmailTicket={
                                    emailTicketList ? emailTicketList[currentPage - 1] : null
                                }
                                onclickReplyTicket={onclickReplyTicket}
                                replyToEmailTicket={replyToEmailTicket}
                                toEmailAddressList={toEmailAddressList}
                                setToEmailAddressList={setToEmailAddressList}
                                ccEmailAddressList={ccEmailAddressList}
                                setCcEmailAddressList={setCcEmailAddressList}
                                bccEmailAddressList={bccEmailAddressList}
                                setBccEmailAddressList={setBccEmailAddressList}
                                listSuggestSearchEmail={listSuggestSearchEmail}
                                setIsEdited={setIsReplyEditData}
                                errorlist={errorReplyTicket}
                                register={registerReplyTicket}
                                setValue={setValueReplyTicket}
                                getValues={getValuesReplyTicket}
                                setError={setErrorReplyTicket}
                                clearErrors={clearErrorReplyTicket}
                                fileReplyUploadList={fileReplyUploadList}
                                setFileReplyUploadList={setFileReplyUploadList}
                                replyDeliverStatus={replyDeliverStatus}
                                setReplyDeliverStatus={setReplyDeliverStatus}
                                currentTicketDeliverStatus={currentTicketDeliverStatus}
                                setCurrentTicketDeliverStatus={setCurrentTicketDeliverStatus}
                                triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                            />
                        ) : (
                            <ContentCurrentEmailTicket
                                originTicket={detailTicket}
                                currentEmailTicket={
                                    emailTicketList ? emailTicketList[currentPage - 1] : null
                                }
                                displayMode={displayMode}
                                onclickReplyTicket={onclickReplyTicket}
                                replyToEmailTicket={replyToEmailTicket}
                                setIsEdited={setIsEdited}
                                currentTicketDeliverStatus={currentTicketDeliverStatus}
                                setCurrentTicketDeliverStatus={setCurrentTicketDeliverStatus}
                                setIsSelectDeliver={setIsSelectDeliver}
                                isEditedCurrentTicket={isEditedCurrentTicket}
                                setIsEditedCurrentTicket={setIsEditedCurrentTicket}
                                isDisableEdit={
                                    isCustomerOrDelivered || replyToEmailTicket
                                        ? isDisableEdit
                                        : isDisableEdit ||
                                          displayMode === Constant.DISPLAY_MODE.VIEW
                                }
                                setIsShowPopupLogout={setIsShowPopupLogout}
                                currentTicketFields={currentTicketFields}
                                toEmailAddressList={toEmailAddressList}
                                setToEmailAddressList={setToEmailAddressList}
                                ccEmailAddressList={ccEmailAddressList}
                                setCcEmailAddressList={setCcEmailAddressList}
                                bccEmailAddressList={bccEmailAddressList}
                                setBccEmailAddressList={setBccEmailAddressList}
                                listSuggestSearchEmail={listSuggestSearchEmail}
                                currentMailSubject={currentMailSubject}
                                setCurrentMailSubject={setCurrentMailSubject}
                                currentMailBody={currentMailBody}
                                setCurrentMailBody={setCurrentMailBody}
                                currentAttachmentError={currentAttachmentError}
                                setCurrentAttachmentError={setCurrentAttachmentError}
                                fileUploadList={fileUploadList}
                                setFileUploadList={setFileUploadList}
                                fileUpdatedList={fileUpdatedList}
                                setFileUpdatedList={setFileUpdatedList}
                                fileDeletedList={fileDeletedList}
                                setFileDeletedList={setFileDeletedList}
                                triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
                                isTriggerReloadCurrentTicket={isTriggerReloadCurrentTicket}
                            />
                        )}

                        <div style={{ marginTop: -20 }}>
                            {/* Render list attachFile chat post on ticketDetail */}
                            <AttachFileChatPost detailTicket={detailTicket} projectInuseDetail={selectedProject}/>
                        </div>

                        <FooterEmailTicket
                            detailTicket={detailTicket}
                            formDetail={formDetail}
                            currentEmailTicket={
                                emailTicketList ? emailTicketList[currentPage - 1] : null
                            }
                        />
                    </div>

                    <DialogConfirmCancelEditTicket
                        saveAndCancel={saveAndCancel}
                        isConfirmCancelEditTicket={isConfirmCancelEditTicket}
                        setIsConfirmCancelEditTicket={setIsConfirmCancelEditTicket}
                        setCloseTabIdState={setCloseTabIdState}
                        detailTicket={detailTicket}
                        // Draft
                        submitSentDraft={() => {}}
                        handleResetFormData={handleResetFormData}
                        handleCancelTicket={() => {
                            setIsEdited(false);
                            removePanelInitData(
                                props?.panelId,
                                props?.tabId,
                                panelInitData,
                                setPanelInitData
                            );
                            const resetIsEdited = false;
                            handleCloseTab(resetIsEdited);
                        }}
                    />

                    <DialogConfirmSoftDeleteTicket
                        isOpen={isOpenPopupSoftDelete}
                        setIsOpen={setIsOpenPopupSoftDelete}
                        submitSoftDelete={submitSoftDelete}
                        detailTicket={detailTicket}
                    />
                    <ConfirmDialog
                        isOpen={isShowDialogRestoreTicket}
                        msgConfirm={trI18n('MSG-CM-CONFIRM-RESTORE-CONTENT')}
                        closeCallBack={onClickCloseConfirmDialog}
                        okCallBack={submitSoftDelete}
                        textClose={trI18n('CM-BUTTON-CANCEL')}
                        textSubmit={trI18n('CM-BUTTON-OK')}
                    />
                    <DataChangePleaseReloadModal
                        {...argsAll}
                        isOpen={isOpenModalReloadPage}
                        setIsOpen={setIsOpenModalReloadPage}
                        content={contentModalReloadPage}
                    />
                    <ConfirmDialog
                        isOpen={isConfirmDialogObj}
                        msgConfirm={trI18n('MSG-CM-CONFIRM-DELETE-CONTENT-COMPLETELY')}
                        closeCallBack={onClickCloseConfirmDialog}
                        okCallBack={onClickOkConfirmDialog}
                        textClose={trI18n('CM-BUTTON-CANCEL')}
                        textSubmit={trI18n('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isOpenPopupTicketError}
                        okCallBack={handleReloadComponent}
                        msgConfirm={trI18n('COMMSG068')}
                        textSubmit={trI18n('COMBTN006')}
                    />
                    <DialogConfirmChangeTicketError
                        {...argsAll}
                        isOpen={isOpenPopupTicketMsg}
                        setIsOpen={setIsOpenPopupTicketMsg}
                    />
                    <DialogConfirmForceEditTicket
                        API={props?.API}
                        setIsLoading={setIsLoading}
                        confirmForceEditTicket={forceEditTicketObject}
                        setConfirmForceEditTicket={setForceEditTicketObject}
                        panelList={panelList}
                        setPanelList={setPanelList}
                        setAssignListPopover={() => {}}
                        triggerReload={setTriggerReloadTicket}
                        panelId={props?.panelId}
                    />
                    <ConfirmDialog
                        isOpen={isShowDialogBackToArrivalTicket}
                        msgConfirm={trI18n('MSG-CM-CONFIRM-BACK-TO-NEW-SUPPORT')}
                        closeCallBack={e => setIsShowDialogBackToArrivalTicket(false)}
                        okCallBack={onClickOkConfirmDialogBackToArrival}
                        textClose={trI18n('CM-BUTTON-CANCEL')}
                        textSubmit={trI18n('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={replyConfirm.isOpen || false}
                        msgConfirm={replyConfirm.msg}
                        closeCallBack={e => setReplyConfirm({ ...replyConfirm, isOpen: false })}
                        okCallBack={onClickCancelReplyTicket}
                        textClose={trI18n('CM-BUTTON-CANCEL')}
                        textSubmit={trI18n('CM-BUTTON-OK')}
                    />
                    <ConfirmDialog
                        isOpen={isShowPopupLogout}
                        msgConfirm={
                            <div>
                                <span>{trI18n('MSG-CM-EXPIRED-SESSION-1')}</span>
                                <br />
                                <span>{trI18n('MSG-CM-EXPIRED-SESSION-2')}</span>
                            </div>
                        }
                        textSubmit={trI18n('CM-BUTTON-OK')}
                        okCallBack={() => signOut()}
                        cancelCallBack={() => setIsShowPopupLogout(false)}
                        cancelClassName={'btn-confirm-cancel'}
                    />
                    <ConfirmDialog
                        isOpen={displayPopupConfirmCancel}
                        msgConfirm={trI18n('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE')}
                        textSubmit={trI18n('CM-BUTTON-OK')}
                        okCallBack={() => {
                            setDisplayPopupConfirmCancel(false);
                            handleResetFormData();
                            setFlagReset(true);
                            setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                        }}
                        textClose={trI18n('CM-BUTTON-CANCEL')}
                        closeCallBack={() => setDisplayPopupConfirmCancel(false)}
                    />
                    <Popover
                        id={'show-more-options-popover'}
                        open={isOpenShowMoreOptionsPopover}
                        anchorEl={anchorShowMoreActionsPopover}
                        onClose={() => setAnchorShowMoreActionsPopover(null)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        style={{ marginLeft: -12 }}
                    >
                        <div style={{ minWidth: 160 }} className="action-list-detail-ticket">
                            <Button variant="text" onClick={handleAddPanelChatThread}>
                                <div className="content">
                                    <img
                                        className="icon"
                                        src="/assets/image/icon-chat.svg"
                                        alt=""
                                    />
                                    <span className="text">{trI18n('helpdesk_chatThread')}</span>
                                </div>
                            </Button>
                            {isDisplayButtonCluster() && (
                                <>
                                    {isDisplayButtonArchivedTicket() &&
                                        getPanelType() !==
                                            Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL && (
                                            <Button
                                                variant="text"
                                                onClick={async () => {
                                                    setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                                                    setAnchorShowMoreActionsPopover(null);
                                                    await handleArchiveTicket(
                                                        null,
                                                        detailTicket,
                                                        setDetailTicket,
                                                        reloadTicketListByPanelType,
                                                        getTicketListType(),
                                                        setTriggerReloadTicket,
                                                        currentUserDetail,
                                                        setTriggerReloadMenu,
                                                        argsAll
                                                    );
                                                }}
                                            >
                                                <div className="content">
                                                    <img
                                                        className="icon"
                                                        src="/assets/image/icon-archive.svg"
                                                        alt=""
                                                    />
                                                    <span className="text">
                                                        {trI18n('HELPDESK_ARCHIVE')}
                                                    </span>
                                                </div>
                                            </Button>
                                        )}
                                    {isDisplayButtonSoftDeleteTicket() && (
                                        <Button variant="text" onClick={handleSoftDeleteTicket}>
                                            <div className="content">
                                                <img
                                                    className="icon"
                                                    src="/assets/image/icon-tabs-delete.svg"
                                                    alt=""
                                                />
                                                <span className="text">
                                                    {trI18n('COMBTN013')}
                                                </span>
                                            </div>
                                        </Button>
                                    )}
                                </>
                            )}
                            {isSoftDelete &&
                                isGeneralUserWithGuest &&
                                !Utils.isDisabledTicketExternalWhenDeskServiceOff(
                                    detailTicket,
                                    corporationDetail
                                ) && (
                                    <Button
                                        variant="text"
                                        onClick={() => {
                                            setAnchorShowMoreActionsPopover(null);
                                            setIsConfirmDialogObj(true);
                                        }}
                                    >
                                        <div className="content">
                                            <img
                                                className="icon"
                                                src="/assets/image/icon-tabs-delete.svg"
                                                alt=""
                                            />
                                            <span className="text">{trI18n('HARD_DELETE')}</span>
                                        </div>
                                    </Button>
                                )}
                        </div>
                    </Popover>

                </div>
            )}
        </div>
    );
}

export default DetailEmailTicket;
